import { useState } from "react"


export const ExamState = () => {
    const [setup, setSetup] = useState({topic_id: '', title:'', uid: '', exam_type: '', list:[{id:'', question:'', question_id:'', category:'', ctype:'', correct:'', agree:'Strongly Agree', disagree:'Strongly Disagree', choices:[{id:0,choices_id:'', key:'', ans:''}, {id:1,choices_id:'', key:'', ans:''}], paragraph:'' },]})
    const [validationErrors, setValidationErrors] = useState({topic_id:'' ,title:'', list:[{id:'',question:'', category:'', correct:'', choices:[{id:'', ans:''}], paragraph:'', },]})
    const [ examType, setExamType] = useState({type: '1', isLoading: false, list:[]})
    const [open, setOpen] = useState(false);
    const [sloader, setSloader] = useState(false);
    const [getTopic, setGetTopic] = useState([]);
    const [cTExam, setCTExam] = useState();
    const [openModal, setOpenModal] = useState(false);

    return {
        open: {data: open, set: setOpen},
        getTopic: {data: getTopic, set: setGetTopic},
        sloader: {data: sloader, set: setSloader},
        setup: {data: setup, set: setSetup},
        examType: {data: examType, set: setExamType},
        validationErrors: {data: validationErrors, set: setValidationErrors},
        ctexam: {data: cTExam, set: setCTExam},
        openModal: {data: openModal, set: setOpenModal},
    }
}